import { IFilterItem } from "../../models/filter-item-model";
import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { BaseFilterQueryService } from "../base-filter-query-service";

export class PureFilterQueryService extends BaseFilterQueryService {
    public addUserFilter(filters: IDictionary<IFilterItem[]>): BaseFilterQueryService {
        Object.keys(filters)?.forEach(filterGroup => {
            let key: string = filterGroup == "Faculteit" || filterGroup == "Faculty" ? "Model/Faculties" : 'Model/Institutes';
            let values: string[] = filters[filterGroup].map(x => x.FilterCodeName);
            let query = this.getListSyntax(key, values);
            this.appendFilter(query);
        });

        return this;
    }
}
